<template>
<g>
<g v-show="valor === 0" v-on:click="cambiar_giro(1)">
<g class="st5">
  <polygon class="st8" points="767.8,378.7 747.1,363.2 767.8,347.8 759.3,336.5 723.7,363.2 759.3,390  "/>
  <path class="st8" d="M799.8,542.5l4.1,13.5c4.8-1.5,9.5-3.3,14.1-5.5l-6.1-12.7C808,539.7,804,541.3,799.8,542.5z"/>
  <path class="st8" d="M774.1,546.3v14.1c5,0,10.1-0.4,15.1-1.1l-2-13.9C782.8,546,778.5,546.3,774.1,546.3z"/>
  <path class="st8" d="M858.8,401.3c-19-28.2-50.7-45.1-84.7-45.1v14.1c48.6,0,88,39.4,88,88c0,29.3-14.6,56.7-38.9,73l7.9,11.7
    C877.9,511.5,890.3,448.1,858.8,401.3z"/>
  <path class="st8" d="M709.9,386.7L657.1,511l92.5,39.3L802.4,426L709.9,386.7z M742.1,531.8l-66.5-28.2l41.7-98.3l66.5,28.2
    L742.1,531.8z"/>
</g>
<g>
  <g>
    <g>
      <polygon class="st9" points="766.7,375.3 745.3,359.3 766.7,343.2 758,331.6 721,359.3 758,387      "/>
      <path class="st9" d="M799.9,545l4.3,13.9c5-1.5,9.9-3.4,14.6-5.7l-6.3-13.1C808.4,542.1,804.2,543.7,799.9,545z"/>
      <path class="st9" d="M773.3,549v14.6c5.2,0,10.4-0.4,15.6-1.1l-2.1-14.4C782.3,548.6,777.8,549,773.3,549z"/>
      <path class="st9" d="M861.1,398.7c-19.7-29.2-52.6-46.7-87.8-46.7v14.6c50.4,0,91.2,40.8,91.2,91.2c0,30.4-15.1,58.7-40.3,75.7
        l8.2,12.1C880.9,512.9,893.7,447.2,861.1,398.7z"/>
      <path class="st9" d="M688.7,533.9H766c9.3,0,15.5-6.2,15.5-15.5v-61.9c0-9.3-6.2-15.5-15.5-15.5v-7.7c0-21.7-17-38.7-38.7-38.7
        c-21.7,0-38.7,17-38.7,38.7v7.7c-9.3,0-15.5,6.2-15.5,15.5v61.9C673.2,527.7,679.4,533.9,688.7,533.9z"/>
      <path class="st7" d="M701,433.4c0-13.9,12.4-26.3,26.3-26.3s26.3,12.4,26.3,26.3v7.7H701L701,433.4L701,433.4z"/>
    </g>
  </g>
</g>
</g>
<g v-show="valor === 1" v-on:click="cambiar_giro(0)">
<g>
	<polygon class="fillverde" points="767.8,378.7 747.1,363.2 767.8,347.8 759.3,336.5 723.7,363.2 759.3,390 	"/>
	<path class="fillverde" d="M799.8,542.5l4.1,13.5c4.8-1.5,9.5-3.3,14.1-5.5l-6.1-12.7C808,539.7,804,541.3,799.8,542.5z"/>
	<path class="fillverde" d="M774.1,546.3v14.1c5,0,10.1-0.4,15.1-1.1l-2-13.9C782.8,546,778.5,546.3,774.1,546.3z"/>
	<path class="fillverde" d="M858.8,401.3c-19-28.2-50.7-45.1-84.7-45.1v14.1c48.6,0,88,39.4,88,88c0,29.3-14.6,56.7-38.9,73l7.9,11.7
		C877.9,511.5,890.3,448.1,858.8,401.3z"/>
	<path class="fillverde" d="M709.9,386.7L657.1,511l92.5,39.3L802.4,426L709.9,386.7z M742.1,531.8l-66.5-28.2l41.7-98.3l66.5,28.2
		L742.1,531.8z"/>
</g>
</g>
</g>
</template>
<script>
export default {
  name: 'giro',
  props: { valor: Number },
  data: function () {
    return {
    }
  },
  methods: {
    cambiar_giro (data) {
      this.$store.dispatch('CAMBIAR_GIRO', data)
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Giro.vue